import actions from './actionTypes';
/* eslint-disable import/prefer-default-export */
export const updateABExperimentsInStore = (configs) => (dispatch) => {
    dispatch({
        type: actions.UPDATE_AB_EXPERIMENTS,
        payload: configs,
    });
};
